/*
  Dot indicators for a horizontally scrolling container.
  Each dot scrolls to its item, and the dot nearest the centre of the
  viewport is marked with aria-current, which the stylesheet styles.
*/
if (!customElements.get('scroll-dots')) {
  class ScrollDots extends HTMLElement {
    connectedCallback() {
      this.scroller = document.getElementById(this.dataset.scroller);
      this.dots = Array.from(this.querySelectorAll('button'));
      if (!this.scroller || !this.dots.length) return;

      this.items = Array.from(this.scroller.children);
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);

      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const item = this.items[index];
          if (item) this.scroller.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        });
      });

      this.update();
    }

    disconnectedCallback() {
      if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const centre = this.scroller.scrollLeft + this.scroller.clientWidth / 2;

      let active = 0;
      let closest = Infinity;

      this.items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft + item.offsetWidth / 2 - centre);
        if (distance < closest) {
          closest = distance;
          active = index;
        }
      });

      this.dots.forEach((dot, index) => {
        if (index === active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('scroll-dots', ScrollDots);
}
